import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import { formatNumber } from '@atc/string-fns';

import { Glyphicon, Text } from 'reaxl';

const renderShippingCopy = (shippingCost) => {
    if (shippingCost === 0) {
        return 'Free Estimated Shipping. Contact for details.';
    } if (shippingCost > 0) {
        return `Estimated Delivery Cost: ${formatNumber({
            value: shippingCost,
            style: 'wholeCurrency',
            formatPretty: true,
        })}. Contact for details.`;
    }
    return 'Contact for shipping options.';
};

function MarketExtensionCard({
    description,
    shippingCost = null,
    uiContext = 'primary',
}) {
    return (
        <div
            data-cmp="market-extension-card"
            className={clsx({ 'align-items-center': uiContext === 'primary', 'align-items-start': uiContext === 'default' }, 'display-flex')}
        >
            <Glyphicon
                glyph="delivery-truck"
                className={clsx({ 'text-accent': uiContext === 'primary' }, 'margin-right-3 text-size-500')}
                aria-hidden="true"
            />
            <div className={clsx({ 'margin-top-2': uiContext === 'primary' })}>
                <Text
                    id="marketExtDescription"
                    weight="bold"
                >
                    {description || 'Delivery'}
                </Text>
                <div id="shippingCost">
                    {renderShippingCopy(parseInt(shippingCost, 10))}
                </div>
            </div>

        </div>
    );
}

MarketExtensionCard.propTypes = {
    uiContext: PropTypes.oneOf(['primary', 'default']),
};

export default MarketExtensionCard;
